export const REPLIES_OF_HIGHLIGHTED_REPLY_LIMIT = 30
export const REPLIES_OF_REPLY_LIMIT = 2
export const REPLY_LOAD_MORE_REPLIES_LIMIT = 5
export const REPLIES_SECTION_HASH = '#replies'
export const REACTIONS_OF_REPLY_LIMIT = 10
export const HIGHLIGHTED_POST_QUERY_PARAM = 'highlight'
